import { ActionTypes } from "../constants/actionTypes";

const initialState = {
  isSidePanelOpen: true,
  resultType: "address",    //As of now address (for addressing) / issue (Issue Inbpx)
};
export const mapPanelControlReducer = (
  state = initialState,
  { type, payload }
) => {
  switch (type) {
    case ActionTypes.SET_SIDE_PANEL_STATUS:
      return { ...state, isSidePanelOpen: payload };
    case ActionTypes.SET_SIDE_PANEL_RESULT_TYPE:
      return { ...state, resultType: payload };
    case ActionTypes.SET_SIDE_PANEL_STATUS_AND_TYPE:
      return {
        ...state,
        resultType: payload.type,
        isSidePanelOpen: payload.status,
      };
    default:
      return state;
  }
};
